module.exports = __webpack_public_path__ + "static/media/drivers-license-back-sample.70b57ee1.svg";